// eslint-disable-next-line import/prefer-default-export
export const GetOrganizationCommitmentSelector = ({
  organizationCommitment: { GetOrganizationCommitment }
}) => GetOrganizationCommitment;

export const PostOrganizationCommitmentSelector = ({
  organizationCommitment: { PostOrganizationCommitment }
}) => PostOrganizationCommitment;
